export const useIconWeather = (iconID) => {
    return (`https://openweathermap.org/img/wn/${iconID}@4x.png`)
}
